import React from "react";
import { Link } from "react-router-dom";

import MoreInfo from "../../assets/Icons/MoreInfo";
import Button from "../Button";

interface ForestRecommendation {
  id: string;
  country_code: string;
  country: string;
  adm1: string;
  adm2: string;
  area: number;
}

const CardForestRecommendationInfo = ({
  id,
  country_code,
  country,
  adm1,
  adm2,
  area,
}: ForestRecommendation) => {
  return (
    <div className="w-full overflow-hidden rounded-xl bg-white p-4 shadow-lg">
      <div className="flex h-full flex-col justify-between">
        <div className="mb-10 flex-row items-start justify-between">
          <div className="flex">
            <div className="grow-0">
              <div className="font-bold text-black">{adm2}</div>
            </div>
            <div className="mt-1 grow cursor-pointer text-gray-600">
              <MoreInfo />
            </div>
          </div>
        </div>
        <p className="mb-4 text-base text-gray-700">
          Forest restoration opportunity in {adm2}, {adm1} of {country}. Total conservation area of{" "}
          {area.toFixed(2)} Ha available for reforestation projects with significant carbon
          sequestration potential.
        </p>
        <div className="flex justify-end gap-2">
          <Link to={`/forest-recommendation/${id}`}>
            <Button variant="outlined">More Details</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CardForestRecommendationInfo;
